import { inject, Injectable } from "@angular/core";
import { ConfirmationComponent } from "@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component";
import { ConfirmationModalData } from "@core/customCDK/cdkCustomMdl/interfaces/confirmation-modal-data";
import { ConfirmationModalService, ConfirmationModalConfig } from "@core/customCDK/cdkCustomMdl/services/confirmation-modal.service";
import { filter, map } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ErrorModalService {
  private confirmationModalService = inject(ConfirmationModalService);

  showError(options?: ConfirmationModalData) {
    const config: ConfirmationModalConfig = {
      data: {
        icon: 'error',
        btnConfirm: '',
        btnClose: 'Okay',
        ...options
      },
    };

    const confirmationRef = this.confirmationModalService.open<ConfirmationComponent>(
      ConfirmationComponent,
      config
    );

    return confirmationRef.events.pipe(
      filter(Boolean),
      map(() => {
        confirmationRef.close();
      })
    );
  }
}
